import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { default as CustomMap } from '../components/Map';
import Json from '../modals/Json';

const styles = {
    card: {
        marginBottom: '10px'
    },
};

class StopVisitMatchingDetails extends Component {
    render() {
        const { problem, solution, classes } = this.props;
        const serviceColors = new Map();
        let stopSegments = [];
        if (problem && solution) {
            stopSegments = solution.stops.map((stop, index) => {
                (stop.visits || []).forEach(visit => serviceColors.set(visit, index));
                return {
                    path: problem.route.filter(coord => stop.start_time <= coord.timestamp && coord.timestamp <= stop.end_time),
                    color: index
                };
            }).filter(segment => segment.path.length > 0);
        }
        return (
            <React.Fragment>
                {solution &&
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h5">
                                Response
                                <Json data={solution} title='Response' />
                            </Typography>
                        </CardContent>
                        <CustomMap
                            markers={problem.services.map(service => ({ 
                                lat: service.location.lat, 
                                lng: service.location.lng, 
                                label: service.id,
                                color: serviceColors.has(service.id) ? serviceColors.get(service.id) : undefined
                            }))}
                            paths={stopSegments}
                        />
                    </Card>
                }
                {problem &&
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h5">
                                Input
                                <Json data={problem} title='Input' />
                            </Typography>
                        </CardContent>
                        <CustomMap
                            markers={problem.services.map(service => ({ lat: service.location.lat, lng: service.location.lng, label: service.id }))}
                            paths={[{ path: problem.route || [] }]}
                        />
                    </Card>
                }
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(StopVisitMatchingDetails);